var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CircularProgress, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
var DetailsLoading = function () {
    var t = useTranslation().t;
    return (_jsxs(Stack, __assign({ alignItems: 'center', justifyContent: 'center', gap: 2, sx: { minHeight: '50vh' } }, { children: [_jsx(CircularProgress, { size: 32, thickness: 4, sx: { color: 'text.secondary' } }), _jsx(Typography, __assign({ variant: 'body1', color: 'text.secondary' }, { children: t('Loading...') }))] })));
};
export default DetailsLoading;
